export const countryCodeOptions = {
  // NANP
  ad: { code: "+376", id: "ad", max: 6, min: 6, name: "Andorra" },

  ae: { code: "+971", id: "ae", max: 9, min: 8, name: "United Arab Emirates" },

  af: { code: "+93", id: "af", max: 9, min: 9, name: "Afghanistan" },

  ag: {
    code: "+1268",
    id: "ag",
    max: 10,
    min: 10,
    name: "Antigua and Barbuda",
  },

  ai: { code: "+1264", id: "ai", max: 10, min: 10, name: "Anguilla" },
  al: { code: "+355", id: "al", max: 9, min: 8, name: "Albania" },
  am: { code: "+374", id: "am", max: 8, min: 8, name: "Armenia" },

  ao: { code: "+244", id: "ao", max: 9, min: 9, name: "Angola" },

  // NANP
  aq: { code: "+672", id: "aq", max: 6, min: 4, name: "Antarctica" },

  // NANP
  ar: { code: "+54", id: "ar", max: 10, min: 10, name: "Argentina" },

  as: { code: "+1684", id: "as", max: 10, min: 10, name: "American Samoa" },

  at: { code: "+43", id: "at", max: 12, min: 7, name: "Austria" },
  au: { code: "+61", id: "au", max: 9, min: 9, name: "Australia" },
  aw: { code: "+297", id: "aw", max: 7, min: 7, name: "Aruba" },
  ax: { code: "+358", id: "ax", max: 12, min: 5, name: "Aland Islands" },
  az: { code: "+994", id: "az", max: 9, min: 8, name: "Azerbaijan" },

  ba: {
    code: "+387",
    id: "ba",
    max: 8,
    min: 8,
    name: "Bosnia and Herzegovina",
  },

  bb: { code: "+1246", id: "bb", max: 10, min: 10, name: "Barbados" },

  bd: { code: "+880", id: "bd", max: 10, min: 8, name: "Bangladesh" },

  be: { code: "+32", id: "be", max: 9, min: 8, name: "Belgium" },

  bf: { code: "+226", id: "bf", max: 8, min: 8, name: "Burkina Faso" },

  bg: { code: "+359", id: "bg", max: 9, min: 8, name: "Bulgaria" },

  // NANP
  bh: { code: "+973", id: "bh", max: 8, min: 8, name: "Bahrain" },

  bi: { code: "+257", id: "bi", max: 8, min: 8, name: "Burundi" },

  bj: { code: "+229", id: "bj", max: 8, min: 8, name: "Benin" },

  bm: { code: "+1441", id: "bm", max: 10, min: 10, name: "Bermuda" },

  bn: { code: "+673", id: "bn", max: 7, min: 7, name: "Brunei Darussalam" },

  bo: { code: "+591", id: "bo", max: 8, min: 8, name: "Bolivia" },

  br: { code: "+55", id: "br", max: 11, min: 10, name: "Brazil" },

  bs: { code: "+1242", id: "bs", max: 10, min: 10, name: "Bahamas" },

  // NANP
  bt: { code: "+975", id: "bt", max: 8, min: 7, name: "Bhutan" },

  bw: { code: "+267", id: "bw", max: 8, min: 7, name: "Botswana" },

  // NANP
  by: { code: "+375", id: "by", max: 10, min: 9, name: "Belarus" },
  bz: { code: "+501", id: "bz", max: 7, min: 7, name: "Belize" },

  ca: { code: "+1", id: "ca", max: 10, min: 10, name: "Canada" },

  // NANP
  cf: {
    code: "+236",
    id: "cf",
    max: 8,
    min: 8,
    name: "Central African Republic",
  },

  ch: { code: "+41", id: "ch", max: 9, min: 9, name: "Switzerland" },

  cl: { code: "+56", id: "cl", max: 9, min: 9, name: "Chile" },

  cm: { code: "+237", id: "cm", max: 9, min: 8, name: "Cameroon" },

  cn: { code: "+86", id: "cn", max: 12, min: 5, name: "China" },

  co: { code: "+57", id: "co", max: 10, min: 9, name: "Colombia" },

  cr: { code: "+506", id: "cr", max: 8, min: 8, name: "Costa Rica" },

  cu: { code: "+53", id: "cu", max: 8, min: 8, name: "Cuba" },

  // NANP
  cv: { code: "+238", id: "cv", max: 7, min: 7, name: "Cape Verde" },
  cy: { code: "+357", id: "cy", max: 8, min: 8, name: "Cyprus" },
  cz: { code: "+420", id: "cz", max: 9, min: 9, name: "Czech Republic" },
  de: { code: "+49", id: "de", max: 11, min: 5, name: "Germany" },
  dj: { code: "+253", id: "dj", max: 8, min: 6, name: "Djibouti" },

  dk: { code: "+45", id: "dk", max: 8, min: 8, name: "Denmark" },

  dm: { code: "+1767", id: "dm", max: 10, min: 10, name: "Dominica" },

  // NANP
  do: { code: "+1", id: "do", max: 10, min: 10, name: "Dominican Republic" },

  dz: { code: "+213", id: "dz", max: 9, min: 8, name: "Algeria" },

  // NANP
  ec: { code: "+593", id: "ec", max: 9, min: 8, name: "Ecuador" },

  ee: { code: "+372", id: "ee", max: 8, min: 7, name: "Estonia" },
  eg: { code: "+20", id: "eg", max: 9, min: 8, name: "Egypt" },
  es: { code: "+34", id: "es", max: 9, min: 9, name: "Spain" },
  et: { code: "+251", id: "et", max: 9, min: 9, name: "Ethiopia" },
  fi: { code: "+358", id: "fi", max: 12, min: 5, name: "Finland" },
  fj: { code: "+679", id: "fj", max: 7, min: 7, name: "Fiji" },
  fr: { code: "+33", id: "fr", max: 9, min: 9, name: "France" },
  gb: { code: "+44", id: "gb", max: 10, min: 7, name: "United Kingdom" },

  gh: { code: "+233", id: "gh", max: 9, min: 8, name: "Ghana" },
  gr: { code: "+30", id: "gr", max: 10, min: 9, name: "Greece" },
  hk: { code: "+852", id: "hk", max: 8, min: 8, name: "Hong Kong" },

  hr: { code: "+385", id: "hr", max: 9, min: 8, name: "Croatia" },
  hu: { code: "+36", id: "hu", max: 9, min: 8, name: "Hungary" },

  id: { code: "+62", id: "id", max: 11, min: 9, name: "Indonesia" },
  ie: { code: "+353", id: "ie", max: 9, min: 7, name: "Ireland" },
  il: { code: "+972", id: "il", max: 9, min: 8, name: "Israel" },
  in: { code: "+91", id: "in", max: 10, min: 10, name: "India" },
  iq: { code: "+964", id: "iq", max: 10, min: 8, name: "Iraq" },
  ir: { code: "+98", id: "ir", max: 10, min: 10, name: "Iran" },
  it: { code: "+39", id: "it", max: 10, min: 6, name: "Italy" },

  jo: { code: "+962", id: "jo", max: 9, min: 8, name: "Jordan" },
  jp: { code: "+81", id: "jp", max: 10, min: 9, name: "Japan" },

  ke: { code: "+254", id: "ke", max: 9, min: 9, name: "Kenya" },

  kh: { code: "+855", id: "kh", max: 9, min: 8, name: "Cambodia" },
  kr: { code: "+82", id: "kr", max: 9, min: 7, name: "South Korea" },
  kw: { code: "+965", id: "kw", max: 8, min: 7, name: "Kuwait" },

  ky: { code: "+1345", id: "ky", max: 10, min: 10, name: "Cayman Islands" },
  lb: { code: "+961", id: "lb", max: 8, min: 7, name: "Lebanon" },
  lk: { code: "+94", id: "lk", max: 9, min: 7, name: "Sri Lanka" },
  ma: { code: "+212", id: "ma", max: 9, min: 8, name: "Morocco" },

  mv: { code: "+960", id: "mv", max: 7, min: 7, name: "Maldives" },
  mx: { code: "+52", id: "mx", max: 10, min: 10, name: "Mexico" },
  my: { code: "+60", id: "my", max: 9, min: 7, name: "Malaysia" },
  ng: { code: "+234", id: "ng", max: 10, min: 7, name: "Nigeria" },
  nl: { code: "+31", id: "nl", max: 9, min: 9, name: "Netherlands" },
  no: { code: "+47", id: "no", max: 8, min: 8, name: "Norway" },

  np: { code: "+977", id: "np", max: 10, min: 8, name: "Nepal" },
  nz: { code: "+64", id: "nz", max: 9, min: 8, name: "New Zealand" },
  om: { code: "+968", id: "om", max: 8, min: 8, name: "Oman" },
  ph: { code: "+63", id: "ph", max: 10, min: 8, name: "Philippines" },
  pk: { code: "+92", id: "pk", max: 10, min: 9, name: "Pakistan" },

  pl: { code: "+48", id: "pl", max: 9, min: 9, name: "Poland" },
  pt: { code: "+351", id: "pt", max: 9, min: 9, name: "Portugal" },

  qa: { code: "+974", id: "qa", max: 8, min: 8, name: "Qatar" },
  ro: { code: "+40", id: "ro", max: 9, min: 9, name: "Romania" },

  ru: { code: "+7", id: "ru", max: 10, min: 10, name: "Russia" },
  sa: { code: "+966", id: "sa", max: 9, min: 8, name: "Saudi Arabia" },
  se: { code: "+46", id: "se", max: 10, min: 7, name: "Sweden" },
  sg: { code: "+65", id: "sg", max: 8, min: 8, name: "Singapore" },
  sv: { code: "+503", id: "sv", max: 8, min: 8, name: "El Salvador" },

  td: { code: "+235", id: "td", max: 8, min: 8, name: "Chad" },
  th: { code: "+66", id: "th", max: 9, min: 8, name: "Thailand" },
  tr: { code: "+90", id: "tr", max: 10, min: 10, name: "Turkey" },
  ua: { code: "+380", id: "ua", max: 9, min: 9, name: "Ukraine" },
  us: { code: "+1", id: "us", max: 10, min: 10, name: "United States" },
  // NANP
  vn: { code: "+84", id: "vn", max: 10, min: 9, name: "Vietnam" },

  ye: { code: "+967", id: "ye", max: 9, min: 8, name: "Yemen" },
  za: { code: "+27", id: "za", max: 9, min: 9, name: "South Africa" },
  zw: { code: "+263", id: "zw", max: 9, min: 9, name: "Zimbabwe" },
};

export const npaLookup = {
  "201": { code: "+1", id: "us", name: "United States" }, // NJ
  "202": { code: "+1", id: "us", name: "United States" }, // DC
  "203": { code: "+1", id: "us", name: "United States" }, // CT
  "204": { code: "+1", id: "ca", name: "Canada" }, // MI
  "205": { code: "+1", id: "us", name: "United States" }, // AL
  "206": { code: "+1", id: "us", name: "United States" }, // WA (Seattle)
  "207": { code: "+1", id: "us", name: "United States" }, // ME
  "208": { code: "+1", id: "us", name: "United States" }, // ID
  "209": { code: "+1", id: "us", name: "United States" }, // CA (Stockton)
  "210": { code: "+1", id: "us", name: "United States" }, // TX (San Antonio)
  "212": { code: "+1", id: "us", name: "United States" }, // NY (Manhattan)
  "213": { code: "+1", id: "us", name: "United States" }, // CA (Los Angeles)
  "214": { code: "+1", id: "us", name: "United States" }, // TX (Dallas)
  "215": { code: "+1", id: "us", name: "United States" }, // PA (Philadelphia)
  "216": { code: "+1", id: "us", name: "United States" }, // OH (Cleveland)
  "217": { code: "+1", id: "us", name: "United States" }, // IL (Springfield)
  "218": { code: "+1", id: "us", name: "United States" }, // MN (Duluth)
  "219": { code: "+1", id: "us", name: "United States" }, // IN (Gary)
  "220": { code: "+1", id: "us", name: "United States" }, // OH
  "223": { code: "+1", id: "us", name: "United States" }, // PA
  "224": { code: "+1", id: "us", name: "United States" }, // IL (Chicago suburbs)
  "225": { code: "+1", id: "us", name: "United States" }, // LA (Baton Rouge)
  "226": { code: "+1", id: "ca", name: "Canada" }, // Manitoba
  "228": { code: "+1", id: "us", name: "United States" }, // MS (Gulfport)
  "229": { code: "+1", id: "us", name: "United States" }, // GA (Albany)
  "231": { code: "+1", id: "us", name: "United States" }, // MI
  "234": { code: "+1", id: "us", name: "United States" }, // OH
  "236": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "239": { code: "+1", id: "us", name: "United States" }, // FL (Fort Myers)
  "240": { code: "+1", id: "us", name: "United States" }, // MD
  "242": { code: "+1", id: "bs", name: "Bahamas" }, // Ontario
  "246": { code: "+1", id: "bb", name: "Barbados" },
  "248": { code: "+1", id: "us", name: "United States" }, // MI (Detroit suburbs)
  "249": { code: "+1", id: "ca", name: "Canada" }, // British Columbia
  "250": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "251": { code: "+1", id: "us", name: "United States" }, // AL (Mobile)
  "252": { code: "+1", id: "us", name: "United States" }, // NC
  "253": { code: "+1", id: "us", name: "United States" }, // WA (Tacoma)
  "254": { code: "+1", id: "us", name: "United States" }, // TX (Waco)
  "256": { code: "+1", id: "us", name: "United States" }, // AL (Huntsville)
  "260": { code: "+1", id: "us", name: "United States" }, // IN (Fort Wayne)
  "262": { code: "+1", id: "us", name: "United States" }, // WI (Milwaukee suburbs)
  "263": { code: "+1", id: "ca", name: "Canada" }, // British Columbia
  "264": { code: "+1", id: "ai", name: "Anguilla" },
  "267": { code: "+1", id: "us", name: "United States" }, // PA (Philadelphia)
  "268": { code: "+1", id: "ag", name: "Antigua and Barbuda" },
  "269": { code: "+1", id: "us", name: "United States" }, // MI
  "270": { code: "+1", id: "us", name: "United States" }, // KY
  "272": { code: "+1", id: "us", name: "United States" }, // PA
  "274": { code: "+1", id: "us", name: "United States" }, // WI
  "276": { code: "+1", id: "us", name: "United States" }, // VA
  "281": { code: "+1", id: "us", name: "United States" }, // TX (Houston)
  "284": { code: "+1", id: "vg", name: "British Virgin Islands" },
  "301": { code: "+1", id: "us", name: "United States" }, // MD
  "302": { code: "+1", id: "us", name: "United States" }, // DE
  "303": { code: "+1", id: "us", name: "United States" }, // CO (Denver)
  "304": { code: "+1", id: "us", name: "United States" }, // WV
  "305": { code: "+1", id: "us", name: "United States" }, // FL (Miami)
  "306": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "307": { code: "+1", id: "us", name: "United States" }, // WY
  "308": { code: "+1", id: "us", name: "United States" }, // NE
  "309": { code: "+1", id: "us", name: "United States" }, // IL
  "310": { code: "+1", id: "us", name: "United States" }, // CA (Los Angeles)
  "312": { code: "+1", id: "us", name: "United States" }, // IL (Chicago)
  "313": { code: "+1", id: "us", name: "United States" }, // MI (Detroit)
  "314": { code: "+1", id: "us", name: "United States" }, // MO (St. Louis)
  "315": { code: "+1", id: "us", name: "United States" }, // NY (Syracuse)
  "316": { code: "+1", id: "us", name: "United States" }, // KS (Wichita)
  "317": { code: "+1", id: "us", name: "United States" }, // IN (Indianapolis)
  "318": { code: "+1", id: "us", name: "United States" }, // LA (Shreveport)
  "319": { code: "+1", id: "us", name: "United States" }, // IA
  "320": { code: "+1", id: "us", name: "United States" }, // MN
  "321": { code: "+1", id: "us", name: "United States" }, // FL (Orlando)
  "323": { code: "+1", id: "us", name: "United States" }, // CA (Los Angeles)
  "325": { code: "+1", id: "us", name: "United States" }, // TX (Abilene)
  "327": { code: "+1", id: "us", name: "United States" }, // FL (Daytona Beach)
  "330": { code: "+1", id: "us", name: "United States" }, // OH (Akron/Canton)
  "331": { code: "+1", id: "us", name: "United States" }, // IL (Chicago suburbs)
  "334": { code: "+1", id: "us", name: "United States" }, // AL (Montgomery)
  "336": { code: "+1", id: "us", name: "United States" }, // NC (Greensboro)
  "337": { code: "+1", id: "us", name: "United States" }, // LA (Lafayette)
  "339": { code: "+1", id: "us", name: "United States" }, // MA (Boston suburbs)
  "341": { code: "+1", id: "us", name: "United States" }, // CA (Oakland)
  "343": { code: "+1", id: "ca", name: "Canada" }, // Saskatchewan
  "346": { code: "+1", id: "us", name: "United States" }, // TX (Houston)
  "347": { code: "+1", id: "us", name: "United States" }, // NY (Bronx, Brooklyn, Queens)
  "351": { code: "+1", id: "us", name: "United States" }, // MA
  "352": { code: "+1", id: "us", name: "United States" }, // FL (Gainesville)
  "354": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "360": { code: "+1", id: "us", name: "United States" }, // WA (Olympia)
  "361": { code: "+1", id: "us", name: "United States" }, // TX (Corpus Christi)
  "364": { code: "+1", id: "us", name: "United States" }, // KY
  "365": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "367": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "368": { code: "+1", id: "ca", name: "Canada" }, // Quebec
  "380": { code: "+1", id: "us", name: "United States" }, // OH
  "382": { code: "+1", id: "ca", name: "Canada" }, // Newfoundland and Labrador
  "385": { code: "+1", id: "us", name: "United States" }, // UT (Salt Lake City)
  "386": { code: "+1", id: "us", name: "United States" }, // FL (Daytona Beach)
  "387": { code: "+1", id: "ca", name: "Canada" }, // Quebec
  "401": { code: "+1", id: "us", name: "United States" }, // RI
  "402": { code: "+1", id: "us", name: "United States" }, // NE
  "403": { code: "+1", id: "ca", name: "Canada" }, // Quebec
  "404": { code: "+1", id: "us", name: "United States" }, // GA (Atlanta)
  "405": { code: "+1", id: "us", name: "United States" }, // OK (Oklahoma City)
  "406": { code: "+1", id: "us", name: "United States" }, // MT
  "407": { code: "+1", id: "us", name: "United States" }, // FL (Orlando)
  "408": { code: "+1", id: "us", name: "United States" }, // CA (San Jose)
  "409": { code: "+1", id: "us", name: "United States" }, // TX (Galveston)
  "410": { code: "+1", id: "us", name: "United States" }, // MD
  "412": { code: "+1", id: "us", name: "United States" }, // PA (Pittsburgh)
  "413": { code: "+1", id: "us", name: "United States" }, // MA (Springfield)
  "414": { code: "+1", id: "us", name: "United States" }, // WI (Milwaukee)
  "415": { code: "+1", id: "us", name: "United States" }, // CA (San Francisco)
  "416": { code: "+1", id: "ca", name: "Canada" }, // Alberta
  "417": { code: "+1", id: "us", name: "United States" }, // MO (Springfield)
  "418": { code: "+1", id: "ca", name: "Canada" }, // Ontario (Toronto)
  "419": { code: "+1", id: "us", name: "United States" }, // OH (Toledo)
  "423": { code: "+1", id: "us", name: "United States" }, // TN (Chattanooga)
  "424": { code: "+1", id: "us", name: "United States" }, // CA (Los Angeles)
  "425": { code: "+1", id: "us", name: "United States" }, // WA (Bellevue/Everett)
  "428": { code: "+1", id: "ca", name: "Canada" }, // Quebec
  "430": { code: "+1", id: "us", name: "United States" }, // TX
  "431": { code: "+1", id: "ca", name: "Canada" }, // Quebec
  "432": { code: "+1", id: "us", name: "United States" }, // TX (Midland/Odessa)
  "434": { code: "+1", id: "us", name: "United States" }, // VA
  "435": { code: "+1", id: "us", name: "United States" }, // UT
  "437": { code: "+1", id: "ca", name: "Canada" }, // Manitoba
  "438": { code: "+1", id: "ca", name: "Canada" }, // Ontario (Toronto overlay)
  "440": { code: "+1", id: "us", name: "United States" }, // OH (Cleveland suburbs)
  "441": { code: "+1", id: "bm", name: "Bermuda" },
  "442": { code: "+1", id: "us", name: "United States" }, // CA (San Diego)
  "443": { code: "+1", id: "us", name: "United States" }, // MD
  "445": { code: "+1", id: "us", name: "United States" }, // PA
  "450": { code: "+1", id: "ca", name: "Canada" }, // Quebec (Montreal)
  "464": { code: "+1", id: "us", name: "United States" }, // IL
  "468": { code: "+1", id: "ca", name: "Canada" }, // Quebec
  "473": { code: "+1", id: "gd", name: "Grenada" },
  "474": { code: "+1", id: "ca", name: "Canada" }, // Quebec
  "475": { code: "+1", id: "us", name: "United States" }, // CT
  "478": { code: "+1", id: "us", name: "United States" }, // GA (Macon)
  "479": { code: "+1", id: "us", name: "United States" }, // AR (Fayetteville)
  "480": { code: "+1", id: "us", name: "United States" }, // AZ (Phoenix)
  "484": { code: "+1", id: "us", name: "United States" }, // PA
  "501": { code: "+1", id: "us", name: "United States" }, // AR (Little Rock)
  "502": { code: "+1", id: "us", name: "United States" }, // KY (Louisville)
  "503": { code: "+1", id: "us", name: "United States" }, // OR (Portland)
  "504": { code: "+1", id: "us", name: "United States" }, // LA (New Orleans)
  "505": { code: "+1", id: "us", name: "United States" }, // NM
  "506": { code: "+1", id: "ca", name: "Canada" }, // Saskatchewan
  "507": { code: "+1", id: "us", name: "United States" }, // MN
  "508": { code: "+1", id: "us", name: "United States" }, // MA
  "509": { code: "+1", id: "us", name: "United States" }, // WA (Spokane)
  "510": { code: "+1", id: "us", name: "United States" }, // CA (Oakland)
  "512": { code: "+1", id: "us", name: "United States" }, // TX (Austin)
  "513": { code: "+1", id: "us", name: "United States" }, // OH (Cincinnati)
  "514": { code: "+1", id: "ca", name: "Canada" }, // New Brunswick
  "515": { code: "+1", id: "us", name: "United States" }, // IA (Des Moines)
  "516": { code: "+1", id: "us", name: "United States" }, // NY (Long Island)
  "517": { code: "+1", id: "us", name: "United States" }, // MI (Lansing)
  "518": { code: "+1", id: "us", name: "United States" }, // NY (Albany)
  "519": { code: "+1", id: "ca", name: "Canada" }, // Quebec (Montreal)
  "520": { code: "+1", id: "us", name: "United States" }, // AZ (Tucson)
  "530": { code: "+1", id: "us", name: "United States" }, // CA (Redding)
  "531": { code: "+1", id: "us", name: "United States" }, // NE
  "534": { code: "+1", id: "us", name: "United States" }, // WI
  "539": { code: "+1", id: "us", name: "United States" }, // OK
  "540": { code: "+1", id: "us", name: "United States" }, // VA
  "541": { code: "+1", id: "us", name: "United States" }, // OR (Eugene)
  "548": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "551": { code: "+1", id: "us", name: "United States" }, // NJ
  "557": { code: "+1", id: "us", name: "United States" }, // MO
  "559": { code: "+1", id: "us", name: "United States" }, // CA (Fresno)
  "561": { code: "+1", id: "us", name: "United States" }, // FL (Palm Beach)
  "562": { code: "+1", id: "us", name: "United States" }, // CA (Long Beach)
  "563": { code: "+1", id: "us", name: "United States" }, // IA (Davenport)
  "564": { code: "+1", id: "us", name: "United States" }, // WA
  "567": { code: "+1", id: "us", name: "United States" }, // OH
  "570": { code: "+1", id: "us", name: "United States" }, // PA (Scranton/Wilkes-Barre)
  "571": { code: "+1", id: "us", name: "United States" }, // VA (Northern Virginia)
  "572": { code: "+1", id: "us", name: "United States" }, // OK
  "573": { code: "+1", id: "us", name: "United States" }, // MO (Jefferson City)
  "574": { code: "+1", id: "us", name: "United States" }, // IN (South Bend)
  "575": { code: "+1", id: "us", name: "United States" },
  // Nova Scotia & PEI
  "579": { code: "+1", id: "ca", name: "Canada" },

  // NM
  "580": { code: "+1", id: "us", name: "United States" },

  // Ontario
  "581": { code: "+1", id: "ca", name: "Canada" },

  // OK
  "582": { code: "+1", id: "us", name: "United States" },

  // Quebec
  "584": { code: "+1", id: "ca", name: "Canada" },

  // PA
  "585": { code: "+1", id: "us", name: "United States" },

  // NY (Rochester)
  "586": { code: "+1", id: "us", name: "United States" },
  // MI (Detroit suburbs)
  "587": { code: "+1", id: "ca", name: "Canada" }, // Quebec
  "601": { code: "+1", id: "us", name: "United States" }, // MS (Jackson)
  "602": { code: "+1", id: "us", name: "United States" }, // AZ (Phoenix)
  "603": { code: "+1", id: "us", name: "United States" }, // NH
  "604": { code: "+1", id: "ca", name: "Canada" }, // Alberta
  "605": { code: "+1", id: "us", name: "United States" }, // SD
  "606": { code: "+1", id: "us", name: "United States" }, // KY
  "607": { code: "+1", id: "us", name: "United States" }, // NY (Binghamton/Ithaca)
  "608": { code: "+1", id: "us", name: "United States" }, // WI (Madison)
  "609": { code: "+1", id: "us", name: "United States" }, // NJ
  "610": { code: "+1", id: "us", name: "United States" }, // PA (Allentown/Bethlehem)
  "612": { code: "+1", id: "us", name: "United States" }, // MN (Minneapolis)
  "614": { code: "+1", id: "us", name: "United States" }, // OH (Columbus)
  "615": { code: "+1", id: "us", name: "United States" }, // TN (Nashville)
  "616": { code: "+1", id: "us", name: "United States" }, // MI (Grand Rapids)
  "617": { code: "+1", id: "us", name: "United States" }, // MA (Boston)
  "618": { code: "+1", id: "us", name: "United States" }, // IL (Southern Illinois)
  "619": { code: "+1", id: "us", name: "United States" }, // CA (San Diego)
  "620": { code: "+1", id: "us", name: "United States" }, // KS
  "622": { code: "+1", id: "ca", name: "Canada" }, // Ontario (Ottawa)
  "623": { code: "+1", id: "us", name: "United States" }, // AZ (Phoenix suburbs)
  "626": { code: "+1", id: "us", name: "United States" }, // CA (Pasadena)
  "628": { code: "+1", id: "us", name: "United States" }, // CA (San Francisco)
  "629": { code: "+1", id: "us", name: "United States" }, // TN (Nashville overlay)
  "630": { code: "+1", id: "us", name: "United States" }, // IL (Chicago suburbs)
  "631": { code: "+1", id: "us", name: "United States" }, // NY (Long Island)
  "636": { code: "+1", id: "us", name: "United States" }, // MO (St. Louis suburbs)
  "639": { code: "+1", id: "ca", name: "Canada" }, // Service (non-geographic, rarely used)
  "641": { code: "+1", id: "us", name: "United States" }, // IA
  "646": { code: "+1", id: "us", name: "United States" }, // NY (Manhattan)
  "647": { code: "+1", id: "ca", name: "Canada" }, // NJ
  "649": { code: "+1", id: "tc", name: "Turks and Caicos Islands" },
  "650": { code: "+1", id: "us", name: "United States" }, // CA (San Mateo/Palo Alto)
  "651": { code: "+1", id: "us", name: "United States" }, // MN (St. Paul)
  "657": { code: "+1", id: "us", name: "United States" }, // CA (Anaheim/Santa Ana)
  "659": { code: "+1", id: "us", name: "United States" }, // AL
  "660": { code: "+1", id: "us", name: "United States" }, // MO
  "661": { code: "+1", id: "us", name: "United States" }, // CA (Bakersfield/Santa Clarita)
  "662": { code: "+1", id: "us", name: "United States" }, // MS
  "667": { code: "+1", id: "us", name: "United States" }, // MD
  "669": { code: "+1", id: "us", name: "United States" }, // CA (San Jose)
  "670": { code: "+1", id: "mp", name: "Northern Mariana Islands" },
  "671": { code: "+1", id: "gu", name: "Guam" },
  "672": { code: "+1", id: "ca", name: "Canada" }, // MA (Boston overlay)
  "678": { code: "+1", id: "us", name: "United States" }, // GA (Atlanta)
  "679": { code: "+1", id: "us", name: "United States" }, // MI
  "683": { code: "+1", id: "ca", name: "Canada" }, // British Columbia
  "684": { code: "+1", id: "as", name: "American Samoa" }, // Territory
  "689": { code: "+1", id: "us", name: "United States" }, // FL (Orlando overlay)
  "701": { code: "+1", id: "us", name: "United States" }, // ND
  "702": { code: "+1", id: "us", name: "United States" }, // NV (Las Vegas)
  "703": { code: "+1", id: "us", name: "United States" }, // VA (Arlington)
  "704": { code: "+1", id: "us", name: "United States" }, // NC (Charlotte)
  "705": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "706": { code: "+1", id: "us", name: "United States" }, // GA (Augusta)
  "707": { code: "+1", id: "us", name: "United States" }, // CA (Santa Rosa)
  "708": { code: "+1", id: "us", name: "United States" }, // IL (Chicago suburbs)
  "712": { code: "+1", id: "us", name: "United States" }, // IA
  "713": { code: "+1", id: "us", name: "United States" }, // TX (Houston)
  "714": { code: "+1", id: "us", name: "United States" }, // CA (Anaheim)
  "715": { code: "+1", id: "us", name: "United States" }, // WI
  "716": { code: "+1", id: "us", name: "United States" }, // NY (Buffalo)
  "717": { code: "+1", id: "us", name: "United States" }, // PA
  "718": { code: "+1", id: "us", name: "United States" }, // NY (Bronx, Queens, Brooklyn)
  "719": { code: "+1", id: "us", name: "United States" }, // CO (Colorado Springs)
  "720": { code: "+1", id: "us", name: "United States" }, // CO (Denver overlay)
  "721": { code: "+1", id: "sx", name: "Sint Maarten" },
  "724": { code: "+1", id: "us", name: "United States" }, // PA (Greensburg)
  "725": { code: "+1", id: "us", name: "United States" }, // NV (Las Vegas overlay)
  "727": { code: "+1", id: "us", name: "United States" }, // FL (St. Petersburg)
  "730": { code: "+1", id: "us", name: "United States" }, // IL
  "731": { code: "+1", id: "us", name: "United States" }, // TN (Jackson)
  "732": { code: "+1", id: "us", name: "United States" }, // NJ
  "734": { code: "+1", id: "us", name: "United States" }, // MI (Ann Arbor)
  "737": { code: "+1", id: "us", name: "United States" }, // TX (Austin overlay)
  "740": { code: "+1", id: "us", name: "United States" }, // OH
  "742": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "743": { code: "+1", id: "us", name: "United States" }, // NC
  "747": { code: "+1", id: "us", name: "United States" }, // CA (Los Angeles overlay)
  "753": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "754": { code: "+1", id: "us", name: "United States" }, // FL (Broward County)
  "757": { code: "+1", id: "us", name: "United States" }, // VA (Norfolk)
  "758": { code: "+1", id: "lc", name: "Saint Lucia" },
  "760": { code: "+1", id: "us", name: "United States" }, // CA (Palm Springs)
  "762": { code: "+1", id: "us", name: "United States" }, // GA (Columbus)
  "763": { code: "+1", id: "us", name: "United States" }, // MN (Minneapolis suburbs)
  "765": { code: "+1", id: "us", name: "United States" }, // IN
  "769": { code: "+1", id: "us", name: "United States" }, // MS
  "770": { code: "+1", id: "us", name: "United States" }, // GA (Atlanta suburbs)
  "772": { code: "+1", id: "us", name: "United States" }, // FL (Treasure Coast)
  "773": { code: "+1", id: "us", name: "United States" }, // IL (Chicago)
  "774": { code: "+1", id: "us", name: "United States" }, // MA
  "775": { code: "+1", id: "us", name: "United States" }, // NV (Reno)
  "778": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "779": { code: "+1", id: "us", name: "United States" }, // IL
  "780": { code: "+1", id: "ca", name: "Canada" }, // British Columbia
  "781": { code: "+1", id: "us", name: "United States" }, // MA
  "782": { code: "+1", id: "ca", name: "Canada" }, // Alberta
  "784": { code: "+1", id: "vc", name: "Saint Vincent and the Grenadines" },
  "785": { code: "+1", id: "us", name: "United States" }, // KS
  "786": { code: "+1", id: "us", name: "United States" }, // FL (Miami overlay)
  "787": { code: "+1", id: "pr", name: "Puerto Rico" },
  "801": { code: "+1", id: "us", name: "United States" }, // UT (Salt Lake City)
  "802": { code: "+1", id: "us", name: "United States" }, // VT
  "803": { code: "+1", id: "us", name: "United States" }, // SC
  "804": { code: "+1", id: "us", name: "United States" }, // VA (Richmond)
  "805": { code: "+1", id: "us", name: "United States" }, // CA (Santa Barbara)
  "806": { code: "+1", id: "us", name: "United States" }, // TX (Lubbock/Amarillo)
  "807": { code: "+1", id: "ca", name: "Canada" }, // Nova Scotia & PEI
  "808": { code: "+1", id: "us", name: "United States" }, // HI
  "809": { code: "+1", id: "do", name: "Dominican Republic" },
  "810": { code: "+1", id: "us", name: "United States" }, // MI (Flint)
  "812": { code: "+1", id: "us", name: "United States" }, // IN (Evansville)
  "813": { code: "+1", id: "us", name: "United States" }, // FL (Tampa)
  "814": { code: "+1", id: "us", name: "United States" }, // PA (Erie)
  "815": { code: "+1", id: "us", name: "United States" }, // IL
  "816": { code: "+1", id: "us", name: "United States" }, // MO (Kansas City)
  "817": { code: "+1", id: "us", name: "United States" }, // TX (Fort Worth)
  "818": { code: "+1", id: "us", name: "United States" }, // CA (San Fernando Valley)
  "819": { code: "+1", id: "ca", name: "Canada" }, // Ontario
  "825": { code: "+1", id: "ca", name: "Canada" }, // Quebec
  "828": { code: "+1", id: "us", name: "United States" }, // NC (Asheville)
  "829": { code: "+1", id: "do", name: "Dominican Republic" },
  "830": { code: "+1", id: "us", name: "United States" }, // TX (Hill Country)
  "831": { code: "+1", id: "us", name: "United States" }, // CA (Monterey Bay)
  "832": { code: "+1", id: "us", name: "United States" }, // TX (Houston overlay)
  "838": { code: "+1", id: "us", name: "United States" }, // NY (Albany overlay)
  "839": { code: "+1", id: "us", name: "United States" }, // SC
  "840": { code: "+1", id: "us", name: "United States" }, // SC
  "841": { code: "+1", id: "us", name: "United States" }, // CA
  "843": { code: "+1", id: "us", name: "United States" }, // IL (Chicago suburbs)
  "845": { code: "+1", id: "us", name: "United States" }, // NY (Hudson Valley)
  "847": { code: "+1", id: "us", name: "United States" }, // NY (Hudson Valley)
  "848": { code: "+1", id: "us", name: "United States" }, // British Columbia
  "849": { code: "+1", id: "do", name: "Dominican Republic" },
  "850": { code: "+1", id: "us", name: "United States" }, // NJ
  "854": { code: "+1", id: "us", name: "United States" }, // FL (Tallahassee)
  "856": { code: "+1", id: "us", name: "United States" }, // SC (Charleston overlay)
  "857": { code: "+1", id: "us", name: "United States" }, // NJ
  "858": { code: "+1", id: "us", name: "United States" }, // MA (Boston overlay)
  "859": { code: "+1", id: "us", name: "United States" }, // CA (San Diego)
  "860": { code: "+1", id: "us", name: "United States" }, // KY (Lexington)
  "862": { code: "+1", id: "us", name: "United States" }, // CT
  "863": { code: "+1", id: "us", name: "United States" }, // NJ
  "864": { code: "+1", id: "us", name: "United States" }, // FL (Lakeland)
  "865": { code: "+1", id: "us", name: "United States" }, // SC (Greenville/Spartanburg)
  "867": { code: "+1", id: "ca", name: "Canada" }, // Alberta
  "868": { code: "+1", id: "tt", name: "Trinidad and Tobago" },
  "869": { code: "+1", id: "kn", name: "Saint Kitts and Nevis" },
  "872": { code: "+1", id: "us", name: "United States" }, // AR
  "873": { code: "+1", id: "ca", name: "Canada" }, // Yukon, Northwest Territories, Nunavut
  "876": { code: "+1", id: "jm", name: "Jamaica" },
  "879": { code: "+1", id: "ca", name: "Canada" }, // Quebec
  "901": { code: "+1", id: "us", name: "United States" }, // TN (Memphis)
  "902": { code: "+1", id: "ca", name: "Canada" }, // Newfoundland and Labrador
  "903": { code: "+1", id: "us", name: "United States" }, // TX
  "904": { code: "+1", id: "us", name: "United States" }, // FL (Jacksonville)
  "905": { code: "+1", id: "ca", name: "Canada" }, // Nova Scotia & Prince Edward Island
  "906": { code: "+1", id: "us", name: "United States" }, // MI (Upper Peninsula)
  "907": { code: "+1", id: "us", name: "United States" }, // AK
  "908": { code: "+1", id: "us", name: "United States" }, // NJ
  "909": { code: "+1", id: "us", name: "United States" }, // CA (San Bernardino)
  "910": { code: "+1", id: "us", name: "United States" }, // NC (Fayetteville/Wilmington)
  "912": { code: "+1", id: "us", name: "United States" }, // GA (Savannah)
  "913": { code: "+1", id: "us", name: "United States" }, // KS (Kansas City)
  "914": { code: "+1", id: "us", name: "United States" }, // NY (Westchester County)
  "915": { code: "+1", id: "us", name: "United States" }, // NY (Westchester County)
  "916": { code: "+1", id: "us", name: "United States" }, // CA (Sacramento)
  "917": { code: "+1", id: "us", name: "United States" }, // NY (Mobile, overlay)
  "918": { code: "+1", id: "us", name: "United States" }, // OK (Tulsa)
  "919": { code: "+1", id: "us", name: "United States" }, // NC (Raleigh)
  "920": { code: "+1", id: "us", name: "United States" }, // WI
  "925": { code: "+1", id: "us", name: "United States" }, // CA (Contra Costa)
  "927": { code: "+1", id: "us", name: "United States" }, // FL
  "928": { code: "+1", id: "us", name: "United States" }, // AZ (Flagstaff/Yuma)
  "929": { code: "+1", id: "us", name: "United States" }, // NY (Bronx, Brooklyn, Queens)
  "930": { code: "+1", id: "us", name: "United States" }, // IN
  "931": { code: "+1", id: "us", name: "United States" }, // TN
  "934": { code: "+1", id: "us", name: "United States" }, // NY (Long Island overlay)
  "935": { code: "+1", id: "us", name: "United States" }, // CA
  "936": { code: "+1", id: "us", name: "United States" }, // TX
  "937": { code: "+1", id: "us", name: "United States" }, // OH (Dayton)
  "938": { code: "+1", id: "us", name: "United States" }, // AL (Huntsville overlay)
  "939": { code: "+1", id: "pr", name: "Puerto Rico" },
  "940": { code: "+1", id: "us", name: "United States" }, // TX
  "941": { code: "+1", id: "us", name: "United States" }, // FL (Sarasota)
  "945": { code: "+1", id: "us", name: "United States" }, // TX
  "947": { code: "+1", id: "us", name: "United States" }, // MI
  "948": { code: "+1", id: "us", name: "United States" }, // VA
  "949": { code: "+1", id: "us", name: "United States" }, // CA (Orange County)
  "951": { code: "+1", id: "us", name: "United States" }, // CA (Riverside)
  "952": { code: "+1", id: "us", name: "United States" }, // MN (Bloomington)
  "954": { code: "+1", id: "us", name: "United States" }, // FL (Fort Lauderdale)
  "956": { code: "+1", id: "us", name: "United States" }, // TX (Laredo)
  "959": { code: "+1", id: "us", name: "United States" }, // CT
  "970": { code: "+1", id: "us", name: "United States" }, // CO
  "971": { code: "+1", id: "us", name: "United States" }, // OR
  "972": { code: "+1", id: "us", name: "United States" }, // TX (Dallas)
  "973": { code: "+1", id: "us", name: "United States" }, // NJ
  "975": { code: "+1", id: "us", name: "United States" }, // MO
  "978": { code: "+1", id: "us", name: "United States" }, // MA
  "979": { code: "+1", id: "us", name: "United States" }, // TX (College Station)
  "980": { code: "+1", id: "us", name: "United States" }, // NC (Charlotte overlay)
  "984": { code: "+1", id: "us", name: "United States" }, // NC (Raleigh overlay)
  "985": { code: "+1", id: "us", name: "United States" }, // LA
  "986": { code: "+1", id: "us", name: "United States" }, // LA
  "989": { code: "+1", id: "us", name: "United States" }, // ID
};

export const COUNTRY_CODES = [
  "+1",
  "+7",
  "+20",
  "+27",
  "+30",
  "+31",
  "+32",
  "+33",
  "+34",
  "+36",
  "+39",
  "+40",
  "+41",
  "+44",
  "+49",
  "+60",
  "+61",
  "+62",
  "+63",
  "+64",
  "+65",
  "+66",
  "+81",
  "+82",
  "+84",
  "+86",
  "+90",
  "+91",
  "+92",
  "+93",
  "+94",
  "+95",
  "+98",
  "+212",
  "+213",
  "+216",
  "+218",
  "+220",
  "+221",
  "+222",
  "+223",
  "+224",
  "+225",
  "+226",
  "+227",
  "+228",
  "+229",
  "+230",
  "+231",
  "+232",
  "+233",
  "+234",
  "+235",
  "+236",
  "+237",
  "+238",
  "+239",
  "+240",
  "+241",
  "+242",
  "+243",
  "+244",
  "+245",
  "+246",
  "+248",
  "+249",
  "+250",
  "+251",
  "+252",
  "+253",
  "+254",
  "+255",
  "+256",
  "+257",
  "+258",
  "+260",
  "+261",
  "+262",
  "+263",
  "+264",
  "+265",
  "+266",
  "+267",
  "+268",
  "+269",
  "+290",
  "+291",
  "+297",
  "+298",
  "+299",
  "+350",
  "+351",
  "+352",
  "+353",
  "+354",
  "+355",
  "+356",
  "+357",
  "+358",
  "+359",
  "+370",
  "+371",
  "+372",
  "+373",
  "+374",
  "+375",
  "+376",
  "+377",
  "+378",
  "+380",
  "+381",
  "+382",
  "+383",
  "+385",
  "+386",
  "+387",
  "+389",
  "+420",
  "+421",
  "+423",
  "+500",
  "+501",
  "+502",
  "+503",
  "+504",
  "+505",
  "+506",
  "+507",
  "+508",
  "+509",
  "+590",
  "+591",
  "+592",
  "+593",
  "+594",
  "+595",
  "+596",
  "+597",
  "+598",
  "+599",
  "+670",
  "+672",
  "+673",
  "+674",
  "+675",
  "+676",
  "+677",
  "+678",
  "+679",
  "+680",
  "+681",
  "+682",
  "+683",
  "+685",
  "+686",
  "+687",
  "+688",
  "+689",
  "+690",
  "+691",
  "+692",
  "+850",
  "+852",
  "+853",
  "+855",
  "+856",
  "+870",
  "+871",
  "+872",
  "+873",
  "+874",
  "+875",
  "+876",
  "+877",
  "+878",
  "+879",
  "+880",
  "+881",
  "+882",
  "+883",
  "+886",
  "+960",
  "+961",
  "+962",
  "+963",
  "+964",
  "+965",
  "+966",
  "+967",
  "+968",
  "+970",
  "+971",
  "+972",
  "+973",
  "+974",
  "+975",
  "+976",
  "+977",
  "+978",
  "+979",
  "+992",
  "+993",
  "+994",
  "+995",
  "+996",
  "+998",
].sort((a, b) => b.length - a.length);
export const extractCountryCode = (num: string) => {
  // normalize (handle "00" international prefix, remove spaces/dashes)
  let n = String(num)
    .trim()
    .replace(/[\s\-().]/g, "");
  if (n.startsWith("00")) n = "+" + n.slice(2);

  if (!n.startsWith("+")) return null;

  // find the first matching code by longest prefix
  for (const code of COUNTRY_CODES) {
    if (n.startsWith(code)) return code;
  }
  return null;
};

export const validatePhone = (num: string) => {
  const cc = extractCountryCode(num);
  if (!cc) return false;

  const countryCode = Object.values(countryCodeOptions).find(
    (c) => c.code === cc,
  );
  if (!countryCode) return false;

  const regexp = new RegExp(
    `\\${cc}\\d{${countryCode.min},${countryCode.max}}$`,
  );

  return regexp.test(num);
};
